import { makeStyles } from '@fluentui/react';
import { TAB_SIZE } from '.';

export const useStyles = makeStyles((theme) => ({
  tabContainer: {
    justifyContent: 'center',
    alignItems: 'center',
    justifyItems: 'center',
    flex: 1,
    borderRadius: TAB_SIZE,
    transition: 'all 200ms ease-in-out',
    cursor: 'pointer',
    ':hover': {
      transform: 'scale(1.1) translateY(-10px)',
    },
  },
  tabContainerSelected: {
    justifyContent: 'center',
    alignItems: 'center',
    justifyItems: 'center',
    flex: 1,
    borderRadius: TAB_SIZE,
    transition: 'all 200ms ease-in-out',
    cursor: 'pointer',
    ':hover': {
      transform: 'scale(1.1) translateY(-10px)',
      boxShadow: '0px 8px 15px rgba(0, 0, 0, 0.2)',
    },
  },
  disabledButton: {
    marginLeft: 20,
    fontSize: 16,
    marginRight: 5,
    ':disabled': {
      color: theme.palette.neutralTertiary,
    },
  },
  toggleButton: {
    justifyContent: 'center',
    alignItems: 'center',
    justifyItems: 'center',
    flex: 1,
    cursor: 'pointer',
  },
  modalContainer: {
    display: 'flex',
    flexFlow: 'column nowrap',
    alignItems: 'stretch',
    minWidth: 600,
  },
}));
